module.exports = "pegasus/assets/preview-20.png";